import $ from 'jquery';
import { getAxiosClient } from '~src/api';
import { onErrorShowMessage } from '~src/errors';

const openStripeCustomerPortal = async (event) => {
  event.preventDefault();
  const httpClient = await getAxiosClient();
  const payload = {
    returnUrl: window.location.href,
  };

  try {
    const response = await httpClient.post(
      `${process.env.USER_API_URL}/stripe/customer-portal`,
      payload
    );

    if (!response.data.customerPortalUrl) {
      onErrorShowMessage();
    } else {
      window.open(response.data.customerPortalUrl, '_blank').focus();
    }
  } catch (err) {
    onErrorShowMessage();
  }
};

export const initOpenStripeCustomerPortalListeners = () => {
  $('body').off('click', '[data-stripe-open-customer-portal]');
  $('body').on(
    'click',
    '[data-stripe-open-customer-portal]',
    openStripeCustomerPortal
  );
};
